import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  InputGroup,
  DropdownButton,
  Dropdown,
  FormControl,
  Form,
} from 'react-bootstrap'
import { RefreshCW } from '../../icons'
import './Calculator.scss'
import { RateExchangeAPI } from '@api'
import { useTranslation } from 'react-i18next'

const LeftPart = styled.div`
  width: 100%;

  & #currency-exchange-from-dropdown {
    border: none;
    border-radius: 0.35em 0 0 0.35em !important;
  }

  & .form-label {
    left: 0;
    top: 0;
    background: #fff;
    margin-top: -0.75em;
    margin-left: 0.75em;
    padding: 0 0.5em;
    color: #776e64;
    font-size: 0.8em;
  }

  & .form-box {
    display: flex;
    .form-control {
      padding-left: 0;
    }
    .input-group-text {
      padding: 0 16px 0 24px;
      border-radius: 0;
      border-width: 1px 0 1px 1px;
      border-color: #edeeee;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      color: #8a8d8f;
    }

    z-index: 2;
    width: 10%;
    input {
      border-width: 1px 1px 1px 0;
      border-color: #edeeee;
      border-radius: 0 6px 6px 0;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      &:focus {
        box-shadow: none;
      }
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0;
    }
  }
`

const RightPart = styled.div`
  width: 100%;

  & input {
    background: transparent !important;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
  }
  & #currency-exchange-to-dropdown {
    border: none;
    border-radius: 0.35em 0 0 0.35em !important;
  }

  & .form-box {
    display: flex;
    .form-control {
      padding-left: 0;
    }
    .input-group-text {
      padding: 0 16px 0 24px;
      border-radius: 0;
      border-width: 1px 0 1px 1px;
      border-color: #edeeee;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      color: #8a8d8f;
    }

    z-index: 2;
    width: 10%;
    input {
      border-width: 1px 1px 1px 0;
      border-color: #edeeee;
      border-radius: 0 6px 6px 0;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      &:focus {
        box-shadow: none;
      }
    }
  }
`

const Container = styled.div`
  padding: 36px 24px 16px 24px;
  display: flex;
  row-gap: 88px;
  position: relative;
  flex-direction: column;

  .dropdown-toggle {
    background: #f2a900;
    width: 100px;
    display: flex;
    color: black;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    padding: 22px 24px;

    &::after {
      margin-left: 0;
    }
  }

  .dropdown-menu {
    z-index: 3;
  }
`

const CursSimulationBox = styled.div`
  z-index: 1;
  position: absolute;
  inset: 0;
  top: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ExchangeButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #edeeee;
  background: #fff;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover svg {
    opacity: 0.8;
  }
`

const Calculator = () => {
  const { t } = useTranslation()
  const [sign1, setSign1] = useState('$')
  const [sign2, setSign2] = useState('Rp')
  const [currency1Buy, setCurrency1Buy] = useState(null)
  const [currency1Sell, setCurrency1Sell] = useState(null)
  const [currency2Sell, setCurrency2Sell] = useState(null)
  useEffect(() => {
    const loadCurrency1 = async (id) => {
      const { data } = await RateExchangeAPI()
      const currency = data.hasil.find(
        (value) => value.currencyAbbreviation === id
      )

      if (currency) {
        if (currency) {
          const sliceCurrency1Buy = currency.ttBuy.toString().slice(0, 5)
          const sliceCurrency1Sell = currency.ttSel.toString().slice(0, 5)
          const sliceCurrency2Sell = currency.ttSel.toString().slice(0, 5)
          setCurrency1Buy(sliceCurrency1Buy)
          setCurrency1Sell(sliceCurrency1Sell)
          setCurrency2Sell(sliceCurrency2Sell)
        } else {
          setCurrency1Buy(0)
          setCurrency1Sell(0)
          setCurrency2Sell(0)
        }
      } else {
        setCurrency1Buy(0)
        setCurrency1Sell(0)
        setCurrency2Sell(0)
      }
    }

    if (currency1Buy === null && currency1Sell === null) {
      loadCurrency1('USD')
    }
  }, [currency1Buy, currency1Sell])

  const loadUpdateCurrency1 = async (id) => {
    const { data } = await RateExchangeAPI()
    const currency = data.hasil.find(
      (value) => value.currencyAbbreviation === id
    )

    if (currency) {
      if (currency) {
        const sliceCurrency1Buy = currency.ttBuy.toString().slice(0, 5)
        const sliceCurrency1Sell = currency.ttSel.toString().slice(0, 5)
        setCurrency1Buy(sliceCurrency1Buy)
        setCurrency1Sell(sliceCurrency1Sell)
      } else {
        setCurrency1Buy(0)
        setCurrency1Sell(0)
      }
    } else {
      setCurrency1Buy(0)
      setCurrency1Sell(0)
    }
  }

  const loadUpdateCurrency2 = async (id) => {
    const { data } = await RateExchangeAPI()
    const currency = data.hasil.find(
      (value) => value.currencyAbbreviation === id
    )

    if (currency) {
      if (currency) {
        const sliceCurrency2Sell = currency.ttSel.toString().slice(0, 5)
        setCurrency2Sell(sliceCurrency2Sell)
      } else {
        setCurrency2Sell(0)
      }
    } else {
      setCurrency2Sell(0)
    }
  }

  const [value1, setValue1] = useState('USD')
  const [value2, setValue2] = useState('IDR')
  const [currency1, setCurrency1] = useState('')
  const [currency2, setCurrency2] = useState('')

  const handleSelect1 = (e) => {
    setValue1(e)
    if (e === 'USD') {
      setSign1('$')
      loadUpdateCurrency1('USD')
    } else if (e === 'SGD') {
      setSign1('S$')
      loadUpdateCurrency1('SGD')
    } else if (e === 'AUD') {
      setSign1('A$')
      loadUpdateCurrency1('AUD')
    } else if (e === 'HKD') {
      setSign1('HK$')
      loadUpdateCurrency1('HKD')
    } else if (e === 'JPY') {
      setSign1('JP¥')
      loadUpdateCurrency1('JPY')
    } else if (e === 'CNY') {
      setSign1('CN¥')
      loadUpdateCurrency1('CNY')
    } else if (e === 'MYR') {
      setSign1('RM')
      loadUpdateCurrency1('MYR')
    } else if (e === 'EUR') {
      setSign1('€')
      loadUpdateCurrency1('EUR')
    } else if (e === 'GBP') {
      setSign1('£')
      loadUpdateCurrency1('GBP')
    } else if (e === 'KRW') {
      setSign1('₩')
      loadUpdateCurrency1('KRW')
    } else if (e === 'IDR') {
      setSign1('Rp')
    }

    setCurrency1('')
    setCurrency2('')
  }

  const handleSelect2 = (e) => {
    setValue2(e)
    if (e === 'USD') {
      setSign2('$')
      loadUpdateCurrency2('USD')
    } else if (e === 'SGD') {
      setSign2('S$')
      loadUpdateCurrency2('SGD')
    } else if (e === 'AUD') {
      setSign2('A$')
      loadUpdateCurrency2('AUD')
    } else if (e === 'HKD') {
      setSign2('HK$')
      loadUpdateCurrency2('HKD')
    } else if (e === 'JPY') {
      setSign2('JP¥')
      loadUpdateCurrency2('JPY')
    } else if (e === 'CNY') {
      setSign2('CN¥')
      loadUpdateCurrency2('CNY')
    } else if (e === 'MYR') {
      setSign2('RM')
      loadUpdateCurrency2('MYR')
    } else if (e === 'EUR') {
      setSign2('€')
      loadUpdateCurrency2('EUR')
    } else if (e === 'GBP') {
      setSign2('£')
      loadUpdateCurrency2('GBP')
    } else if (e === 'KRW') {
      setSign2('₩')
      loadUpdateCurrency2('KRW')
    } else if (e === 'IDR') {
      setSign2('Rp')
    }

    setCurrency1('')
    setCurrency2('')
  }

  const handleSwipeForm = () => {
    handleSelect1(value2)
    handleSelect2(value1)
    setCurrency1('')
    setCurrency2('')
    setSign1(sign2)
    setSign2(sign1)
  }

  // add dot every 3 digits : 3000000 -> 3.000.000
  const handleChange = (e) => {
    const re = /^[0-9.,]+$/

    if (e.target.value === '' || re.test(e.target.value)) {
      setCurrency1(e.target.value)
      handleConverterCurrency(e)
    }
  }

  const handleConverterCurrency = (e) => {
    e.target.value = e.target.value.replace(',', '.')

    if (e.target.value === '') {
      setCurrency2('')
    } else {
      if (value1 === value2) {
        setCurrency2((e.target.value * 1).toLocaleString('id-ID'))
      } else if (value1 === 'IDR') {
        setCurrency2(
          round(e.target.value / currency2Sell, 2).toLocaleString('id-ID')
        )
      } else {
        if (value2 === 'IDR') {
          setCurrency2(
            round(e.target.value * currency1Buy, 2).toLocaleString('id-ID')
          )
        } else {
          setCurrency2(
            round(
              (e.target.value * currency1Buy) / currency2Sell,
              2
            ).toLocaleString('id-ID')
          )
        }
      }
    }
  }

  // const handleChange = (e) => {
  //   const re = /^[0-9\b]+$/
  //   if (e.target.value === '' || re.test(e.target.value)) {
  //     setCurrency1(e.target.value)
  //     handleConverterCurrency(e)
  //   }
  // }

  // const handleConverterCurrency = (e) => {
  //   if (e.target.value === '') {
  //     setCurrency2('')
  //   } else {
  //     if (value1 === value2) {
  //       setCurrency2(e.target.value * 1)
  //     } else if (value1 === 'IDR') {
  //       setCurrency2(round(e.target.value / currency2Sell, 2))
  //     } else {
  //       if (value2 === 'IDR') {
  //         setCurrency2(round(e.target.value * currency1Buy, 2))
  //       } else {
  //         setCurrency2(
  //           round((e.target.value * currency1Buy) / currency2Sell, 2)
  //         )
  //       }
  //     }
  //   }
  // }

  function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
  }

  return (
    <Container>
      <LeftPart>
        <InputGroup className="mb-3">
          <DropdownButton
            as={InputGroup.Prepend}
            variant="outline-secondary"
            title={value1}
            id="currency-exchange-from-dropdown"
            onSelect={handleSelect1}
          >
            <Dropdown.Item eventKey="USD">USD</Dropdown.Item>
            <Dropdown.Item eventKey="IDR">IDR</Dropdown.Item>
            <Dropdown.Item eventKey="SGD">SGD</Dropdown.Item>
            <Dropdown.Item eventKey="AUD">AUD</Dropdown.Item>
            <Dropdown.Item eventKey="HKD">HKD</Dropdown.Item>
            <Dropdown.Item eventKey="JPY">JPY</Dropdown.Item>
            <Dropdown.Item eventKey="CNY">CNY</Dropdown.Item>
            <Dropdown.Item eventKey="MYR">MYR</Dropdown.Item>
            <Dropdown.Item eventKey="EUR">EUR</Dropdown.Item>
            <Dropdown.Item eventKey="GBP">GBP</Dropdown.Item>
            <Dropdown.Item eventKey="KRW">KRW</Dropdown.Item>
          </DropdownButton>
          <div className="form-box position-relative flex-grow-1 bd-highlight">
            <Form.Label className="position-absolute">
              {t('masukan_jumlah')}
            </Form.Label>
            <InputGroup.Text>{sign1}</InputGroup.Text>
            <FormControl
              type="search"
              pattern="[0-9]*"
              className="h-100 w-100"
              aria-describedby="currency-exchange-form-input"
              value={currency1}
              onChange={(e) => {
                handleChange(e)
              }}
            />
          </div>
        </InputGroup>
      </LeftPart>
      <RightPart>
        <InputGroup className="mb-3">
          <DropdownButton
            as={InputGroup.Prepend}
            variant="outline-secondary"
            title={value2}
            id="currency-exchange-to-dropdown"
            onSelect={handleSelect2}
          >
            <Dropdown.Item eventKey="USD">USD</Dropdown.Item>
            <Dropdown.Item eventKey="IDR">IDR</Dropdown.Item>
            <Dropdown.Item eventKey="SGD">SGD</Dropdown.Item>
            <Dropdown.Item eventKey="AUD">AUD</Dropdown.Item>
            <Dropdown.Item eventKey="HKD">HKD</Dropdown.Item>
            <Dropdown.Item eventKey="JPY">JPY</Dropdown.Item>
            <Dropdown.Item eventKey="CNY">CNY</Dropdown.Item>
            <Dropdown.Item eventKey="MYR">MYR</Dropdown.Item>
            <Dropdown.Item eventKey="EUR">EUR</Dropdown.Item>
            <Dropdown.Item eventKey="GBP">GBP</Dropdown.Item>
            <Dropdown.Item eventKey="KRW">KRW</Dropdown.Item>
          </DropdownButton>
          <div className="form-box position-relative flex-grow-1 bd-highlight">
            <InputGroup.Text>{sign2}</InputGroup.Text>
            <FormControl
              className="h-100 w-100"
              aria-describedby="currency-exchange-to-input"
              value={currency2}
              readOnly
            />
          </div>
        </InputGroup>
      </RightPart>
      <CursSimulationBox>
        <ExchangeButton onClick={handleSwipeForm}>
          <RefreshCW fill="#8A8D8F" />
        </ExchangeButton>
      </CursSimulationBox>
    </Container>
  )
}

export default Calculator
